
import { component } from '@/helpers/vueTyped';
import store, { dispatch } from '@/store';
import router from '@/router';
import { TournamentSport, Tournament } from '@/components/Sport/types';
import TournamentSelectItem from './TournamentSelectItem.vue';

interface TournamentSelectProps {
  selectedTourId?: string;
  options: TournamentSport;
  menuClosedCallback: () => void;
}

export default component<TournamentSelectProps>()({
  name: 'TournamentSelect',

  props: {
    options: {},
    menuClosedCallback: {},
    selectedTourId: {},
  },

  computed: {
    sport(): string {
      return store.state.navigationState.sport!;
    },

    firstTourId(): string {
      return (
        this.options.groups[0]?.tournaments[0].id ?? this.options.tournaments[0].id
      );
    },

    lastTourId(): string {
      const lastTours = this.options.tournaments?.length
        ? this.options.tournaments
        : this.options.groups[this.options.groups.length - 1].tournaments;
      return lastTours[lastTours.length - 1].id;
    },
  },

  methods: {
    async optionSelected(tour: Tournament): Promise<void> {
      const tournamentFeedId = tour.id;
      const sportFeedId = store.state.navigationState.sport!;

      try {
        this.analytics(tour);
        await router.push({
          name: 'sportHome',
          params: { sportFeedId, tournamentFeedId },
        });
      } finally {
        this.menuClosedCallback();
      }
    },

     analytics(tour: Tournament) {
      this.$analytics.logEvent('ss_sport_navigation', {
        sport: tour.sport ?? '',
        selected_tournament: tour.label ?? '',
      });
    },

    focus() {
      if (this.selectedTourId) {
        (this.$refs[`tour-${this.selectedTourId}`] as HTMLElement).focus();
      } else {
        (this.$refs[`tour-${this.firstTourId}`] as HTMLElement).focus();
      }
    },

    closeOnArrowUp(e: KeyboardEvent) {
      if (e.key === 'ArrowUp') {
        e.stopPropagation();
        this.menuClosedCallback();
      }
    },

    closeOnArrowDown(e: KeyboardEvent) {
      if (e.key === 'ArrowDown') {
        e.stopPropagation();
        this.menuClosedCallback();
      }
    },
  },

  mounted() {
    this.focus();

    (this.$refs[`tour-${this.options.id}`] as HTMLElement).addEventListener(
      'keydown',
      this.closeOnArrowUp,
    );
    (this.$refs[`tour-${this.lastTourId}`] as HTMLElement).addEventListener(
      'keydown',
      this.closeOnArrowDown,
    );
  },

  created() {
    dispatch('setMainBlurred', [true]);

    this.$spatialFocus.pushGlobalOverride('back', this.menuClosedCallback);
    this.$spatialFocus.pushGlobalOverride('left', () => true);
    this.$spatialFocus.pushGlobalOverride('right', () => true);
  },

  destroyed() {
    dispatch('setMainBlurred', [false]);

    this.$spatialFocus.popGlobalOverride('back');
    this.$spatialFocus.popGlobalOverride('left');
    this.$spatialFocus.popGlobalOverride('right');
  },

  render(h) {
    return (
      <div class='background'>
        <div
          key={this.options.label}
          class='tournament-select'
          v-spatial-container={{
            name: 'tournamentSelect',
            selector: '.selectable-tour',
          }}
        >
          <div class='title select-row'>
            {`${this.options.label} Tournaments`}
          </div>

          <TournamentSelectItem
            tour={{
              id: this.options.id,
              image: this.options.image,
              label: `All ${this.options.label}`,
              providerId: this.options.providerId,
              legacyId: this.options.legacyId,
              sport: this.options.sport,
              classification: this.options.classification,
            }}
            optionSelected={this.optionSelected}
          />

          {this.options.groups?.map((group) => (
            <fragment>
              <div class='group select-row'>{group.label}</div>
              {group.tournaments.map((tour) => (
                <TournamentSelectItem
                  tour={tour}
                  optionSelected={this.optionSelected}
                />
              ))}
            </fragment>
          ))}

          {Boolean(this.options.tournaments?.length) && (
            <div class='group select-row'>others</div>
          )}

          {this.options.tournaments.map((tour) => (
            <TournamentSelectItem
              tour={tour}
              optionSelected={this.optionSelected}
            />
          ))}
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-0191744b/TournamentSelect.vue" });